<script setup lang="ts">
import { computed } from 'vue'

import { useKanbanLog } from '@entities/kanban-comment'
import { LoaderBlock } from '@shared/ui/loaders'
import { CardAdmin } from '@shared/ui/cards'

import { useTasksKanbanStore } from '../model/store'
import TasksKanbanLogItem from './TasksKanbanLogItem.vue'
import { useKanbanLogsInfiniteScroll } from '../model/kanban-logs-infinite-scroll.hook'

defineOptions({
  name: 'TasksKanbanLog',
})

const tasksKanbanStore = useTasksKanbanStore()
const route = useRoute()

const id = computed<string>(() => route.params.id as string)

const { isMainLog, isLastLog } = useKanbanLog()
const { isLoadingMore } = useKanbanLogsInfiniteScroll({ id })
</script>

<template>
  <CardAdmin title="Changelog">
    <TasksKanbanLogItem
      v-for="(log, index) in tasksKanbanStore.getLogs"
      :key="log.id"
      :log="log"
      :main="isMainLog(log, index, tasksKanbanStore.getLogs)"
      :last="isLastLog(log, index, tasksKanbanStore.getLogs)"
    />
    <div
      v-if="isLoadingMore"
      class="tasks-kanban-log__loader"
    >
      <LoaderBlock size="sm" />
    </div>
  </CardAdmin>
</template>

<style scoped lang="scss" src="./TasksKanbanLog.scss" />